<template>
  <div v-if="isReady" class="pc-page">
    <pc-modal-wrapper v-if="showTestModeModal">
      <pc-modal-container :show-close="true" @close="setShowTestModeModal(false)">
        <div class="pc-modal__content">
          <h3 v-html="settings[`STARTUP_TEXT_${testMessageLang}`]"></h3>
        </div>
        <div class="pc-modal__actions test-message-btn">
          <pc-button @click="setShowTestModeModal(false)">
            {{ settings[`STARTUP_BUTTON_TEXT_${testMessageLang}`] }}
          </pc-button>
        </div>
      </pc-modal-container>
    </pc-modal-wrapper>
    <pc-status-bar
      class="pc-header"
      :show-close="showMenu"
      @open-menu="openMenu"
    />
    <div class="pc-main">
      <pc-menu
        v-click-outside="hideMenu"
        :class="{'active': showMenu}"
        @close="hideMenu"
        @logout="showLogout"
      />
      <otp-verification v-if="showOtpVerification" />
      <div v-if="!needToVerifyPhone" class="pc-content">
        <transition name="fade" mode="out-in">
          <router-view></router-view>
        </transition>

      </div>
      <pc-modal-wrapper v-if="showExitModal">
        <pc-modal-container @close="showExitModal = false">
          <div class="pc-modal__content">
            <h3>
              {{ $t('pc.general.confirm-exit') }}
            </h3>
          </div>
          <div class="pc-modal__actions">
            <pc-button variant="dark" :disabled="false" @click.native="logout">
              {{ $t('pc.general.exit') }}
            </pc-button>
            <pc-button variant="void" :disabled="false" @click.native="showExitModal = false">
              {{ $t('pc.general.stay') }}
            </pc-button>
          </div>
        </pc-modal-container>
      </pc-modal-wrapper>
    </div>
    <pc-modal-wrapper v-if="showPhoneNotVerifiedModal">
      <pc-modal-container :show-close="false">
        <div class="pc-modal__content">
          <icu-icon class="pc-warning pc-modal__image no-margin-down"></icu-icon>
          <h3 v-html="$t('verification-modal.phone-need-verification-title', {phone: userInfo.phone})" />
        </div>
        <div class="pc-modal__actions vertical">
          <pc-button
            :disabled="false"
            @click.native="verifyPhone"
          >
            {{ $t('verification-modal.go-to-verification') }}
          </pc-button>
          <div class="pc-modal__contacts">
            <p>
              {{ $t('verification-modal.phone-verification-text') }}
            </p>
            <icu-contacts email-to="onboarding"></icu-contacts>
          </div>
        </div>
      </pc-modal-container>
    </pc-modal-wrapper>
    <pc-modal-wrapper v-if="showSuccessVerifiedModal">
      <pc-modal-container :show-close="false">
        <div class="pc-modal__content">
          <icu-icon class="pc-success pc-modal__image no-margin-down"></icu-icon>
          <h3>
            {{ $t('pc.verification.verification-success-title') }}
          </h3>
          <div class="pc-modal__text" v-html="$t('pc.verification.verification-success-message')" />

        </div>
        <div class="pc-modal__actions vertical">
          <pc-button
            :disabled="false"
            @click.native="showSuccessVerifiedModal = false"
          >
            {{ $t('pc.verification.return') }}
          </pc-button>
        </div>
      </pc-modal-container>
    </pc-modal-wrapper>
  </div>
</template>

<script>
import PcStatusBar from '@/components/views/PrivateCabinet/PcStatusBar'
import PcMenu from '@/components/views/PrivateCabinet/PcMenu'
import OtpVerification from '@/components/views/PrivateCabinet/OtpVerification'
import {mapActions, mapGetters} from 'vuex'
import PcModalWrapper from '@/components/modals/PcModalWrapper'
import PcModalContainer from '@/components/modals/PcModalContainer'
import PcButton from '@/components/common/PcButton'
import {api} from '@/api/api'
import IcuIcon from '@/components/common/IcuIcon'
import IcuContacts from '@/components/common/IcuContacts'
import { v4 as uuidv4 } from 'uuid'

export default {
  name: 'PrivateCabinet',
  components: {
    IcuContacts,
    IcuIcon,
    PcButton,
    PcModalContainer,
    PcModalWrapper,
    OtpVerification,
    PcMenu,
    PcStatusBar
  },
  data() {
    return {
      isReady: false,
      showMenu: false,
      showExitModal: false,
      showPhoneNotVerifiedModal: false,
      showSuccessVerifiedModal: false,
      verifyId: null
    }
  },
  computed: {
    ...mapGetters(['showOtpVerification', 'userInfo', 'otpConfirmed','settings', 'showTestModeModal']),
    needToVerifyPhone() {
      return this.userInfo.can_send_sms &&  !this.userInfo.phone_is_verified
    },
    testMessageLang() {
      return this.$i18n.locale === 'uk'? 'UA' : 'EN'
    }
  },
  watch: {
    needToVerifyPhone() {
      this.checkPhoneIsVerified()
    },
    otpConfirmed(newVal){
      if(newVal === this.verifyId) {
        this.showSuccessVerifiedModal = true
        this.$store.dispatch('setUserInfo')
        this.getData()
      }
    },
  },

  async beforeMount() {
   if(!Object.keys(this.userInfo).length) {
      await this.$router.push({name:'login'})
   } else {
     this.isReady = true
   }

  },
  mounted (){
   this.checkPhoneIsVerified()
   this.$webSocketsConnect()

  },
  methods: {
    ...mapActions(['setShowTestModeModal']),
    checkPhoneIsVerified() {
      if(this.needToVerifyPhone){
        this.showPhoneNotVerifiedModal = true
      } else {
        this.getData()
      }
    },
   showLogout() {
     this.hideMenu()
     this.showExitModal = true
   },
    getData() {
      this.$store.dispatch('setDocumentTypes')
    },
    openMenu() {
      if (!this.showMenu) {
        this.showMenu = true
      }
    },

    hideMenu(e) {
     if( !e || !e.target.classList.contains('menu-btn')) {
       if (window.innerWidth <= 1200 && this.showMenu) {
         setTimeout(() => {
           this.showMenu = false
         },200)

       }
     }
    },

    verifyPhone() {
      this.showPhoneNotVerifiedModal = false
      const id = uuidv4()
      this.verifyId = id
     this.$store.dispatch('showOtp',{
       id,
       getCodeApi: api.auth.getPhoneVerifyCode,
       getCodeApiData:{},
       confirmCodeApi: api.auth.confirmPhoneVerifyCode,
       hideCountdown: false,
       phoneOnly: true,
       showClose: false
     })
    },
    logout() {
      this.$store.dispatch('logout')
      this.$router.push({name:'login'})
    }
  }
}
</script>

<style  scoped lang="scss">
@import "~@/assets/scss/views/register-common.scss";
h3 {
  padding-top: 30px;
  padding-bottom: 30px !important;
}
.pc-modal__text {
  font-size: 20px;
  padding-bottom: 0px !important;
}
.pc-modal__actions  >  *{
  flex-basis: 45%;
  flex-grow: 0 !important;
}

.test-message-btn {
  .pc-btn {
    flex-grow: 1 !important;
  }
}
</style>
